var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmolGeorgia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#FF9D00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 38.3873V33.75H13.75V39.8159L16.25 38.3873Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4045 33.9635C23.3092 33.9159 23.2033 33.8934 23.0969 33.8982C22.9904 33.903 22.887 33.9349 22.7964 33.9909C22.7058 34.047 22.631 34.1252 22.5791 34.2182C22.5272 34.3113 22.5 34.4161 22.5 34.5226V38.125H23.75V34.5226C23.7504 34.4064 23.7182 34.2925 23.6572 34.1937C23.5961 34.0949 23.5085 34.0151 23.4045 33.9635Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 31.285L23.1349 29.9695L25.1847 30.6527L27.5 31.3143V28.75H18.75V31.285Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4407 20.625H22.1172H24.1328H25.4504H26.25H27.8093L23.75 16.8338V15.625H25V14.375H23.75V13.125H22.5V14.375H21.25V15.625H22.5V16.8338L18.4407 20.625Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 32.035L17.5 31.66V30.625H14.0625L12.6562 32.5H16.25V32.035Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 21.875H18.75V27.5H27.5V21.875ZM21.25 26.25H20V23.125H21.25V26.25ZM23.75 26.25H22.5V23.125H23.75V26.25ZM26.25 26.25H25V23.125H26.25V26.25Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.375 28.75H45.625V31.25H39.375V28.75Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.375 38.125H45.625V32.5H39.375V38.125ZM43.125 33.75H44.375V36.875H43.125V33.75ZM40.625 33.75H41.875V36.875H40.625V33.75Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9805 27.4715L39.009 27.5H45.9912L46.0197 27.4715L43.1251 24.1634V22.5H44.3751V21.25H43.1251V20H41.8751V21.25H40.6251V22.5H41.8751V24.1634L38.9805 27.4715Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30 32.5H33.5938L32.1875 30.625H28.75V31.6714L30 32.0286V32.5Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30 38.3873L32.5 39.8159V33.75H30V38.3873Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 47.5V39.375H38.125V47.5H33.125V41.6127L28.75 39.1127V32.9715L24.8023 31.8429L23.1151 31.2805L17.5 32.965V39.1127L13.125 41.6127V47.5H11.25V48.75H48.75V47.5H46.875ZM21.25 34.5226C21.2488 34.1741 21.3453 33.8323 21.5285 33.5359C21.7117 33.2394 21.9743 33.0003 22.2865 32.8455C22.547 32.716 22.834 32.6486 23.125 32.6486C23.416 32.6486 23.703 32.716 23.9635 32.8455C24.2757 33.0003 24.5383 33.2394 24.7215 33.5359C24.9047 33.8323 25.0012 34.1741 25 34.5226V39.375H21.25V34.5226ZM19.375 43.75H18.125V42.5H19.375V43.75ZM20 39.375H18.75V38.125H20V39.375ZM25.625 47.5H24.375V43.75C24.375 43.4185 24.2433 43.1005 24.0089 42.8661C23.7745 42.6317 23.4565 42.5 23.125 42.5C22.7935 42.5 22.4755 42.6317 22.2411 42.8661C22.0067 43.1005 21.875 43.4185 21.875 43.75V47.5H20.625V43.75C20.625 43.087 20.8884 42.4511 21.3572 41.9822C21.8261 41.5134 22.462 41.25 23.125 41.25C23.788 41.25 24.4239 41.5134 24.8928 41.9822C25.3616 42.4511 25.625 43.087 25.625 43.75V47.5ZM26.25 38.125H27.5V39.375H26.25V38.125ZM28.125 43.75H26.875V42.5H28.125V43.75ZM42.5 46.25H41.25V45H42.5V46.25ZM43.125 41.25H44.375V42.5H43.125V41.25ZM45.625 45H44.375V43.75H45.625V45Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmolGeorgia);
export default __webpack_public_path__ + "static/media/smolGeorgia.69208823bbed5a92487a2fbba09f2689.svg";
export { ForwardRef as ReactComponent };